import React, { useCallback } from 'react';

import { FilterList as FilterIcon } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

import { Experiences as EC } from '@luxuryescapes/contract-svc-experience';

import TicketModeSelect from './TicketModeSelect';

interface Props {
  ticketModes: Array<EC.TicketModeField>;
  value: Record<string, string>;
  onChange: (map: Record<string, string>) => void;
  disabled?: boolean;
}

function TicketModeFilters({ ticketModes, value, onChange, disabled }: Props) {
  const handleChange = useCallback(
    (updated: Record<string, string | undefined>) => {
      onChange(
        Object.fromEntries(Object.entries(updated).filter(([, v]) => v !== undefined)) as Record<string, string>,
      );
    },
    [onChange],
  );

  return (
    <Box
      sx={{
        bgcolor: 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 1,
        px: 2,
        py: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
        <FilterIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        <Typography variant="overline" color="text.secondary">
          Ticket mode filters
        </Typography>
      </Stack>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        {ticketModes.map((field) => (
          <TicketModeSelect
            key={field.key}
            field={field}
            selectedOptions={value}
            onChange={handleChange}
            disabled={disabled}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default TicketModeFilters;
